import api from '@/services/api'

// 创建退货单
export function createPurchaseReturn(data, wholesalerId, userId) {
  return api.post('/purchase-return', data, { params: { wholesalerId, userId } })
}

// 获取退货单列表
export function getPurchaseReturnList(wholesalerId, params) {
  return api.get('/purchase-return/list', {
    params: { wholesalerId, ...params }
  })
}

// 获取退货单详情
export function getPurchaseReturnDetail(id, wholesalerId) {
  return api.get(`/purchase-return/${id}`, { params: { wholesalerId } })
}

// 审核通过
export function approvePurchaseReturn(id, wholesalerId, userId, reviewNote) {
  return api.post(`/purchase-return/${id}/approve`, null, {
    params: { wholesalerId, userId, reviewNote }
  })
}

// 审核拒绝
export function rejectPurchaseReturn(id, wholesalerId, userId, reviewNote) {
  return api.post(`/purchase-return/${id}/reject`, null, {
    params: { wholesalerId, userId, reviewNote }
  })
}

// 确认退货收货
export function receivePurchaseReturn(id, wholesalerId, userId) {
  return api.post(`/purchase-return/${id}/receive`, null, {
    params: { wholesalerId, userId }
  })
}

// 执行退款
export function refundPurchaseReturn(id, wholesalerId, userId, refundNote, refundProofUrls, refundAmount, refundType, refundStatus) {
  return api.post(`/purchase-return/${id}/refund`, null, {
    params: { wholesalerId, userId, refundNote, refundProofUrls, refundAmount, refundType, refundStatus }
  })
}

// 取消退货单
export function cancelPurchaseReturn(id, wholesalerId, userId) {
  return api.post(`/purchase-return/${id}/cancel`, null, {
    params: { wholesalerId, userId }
  })
}

// 根据进货单ID查询退货单列表
export function getReturnsByPurchaseId(purchaseId, wholesalerId) {
  return api.get(`/purchase-return/by-purchase/${purchaseId}`, {
    params: { wholesalerId }
  })
}
